import { render, staticRenderFns } from "./TmpMessage.vue?vue&type=template&id=32a22ade"
import script from "./TmpMessage.vue?vue&type=script&lang=js"
export * from "./TmpMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports